// src/routes.js
import React from 'react';
import { Route, Routes } from 'react-router-dom';
import Dashboard from './pages/Dashboard';
import AdminDashboard from './pages/AdminDashboard';
import Patients from './pages/Patients';
import Appointments from './pages/Appointments';
import Notifications from './pages/Notification';
import Subscriptions from './pages/Subscriptions';


import Packages from './pages/Packages';
import Couriers from './pages/Couriers';
import Shipments from './pages/Shipments';
import Collections from './pages/Collections';
import Accounts from './pages/Accounts';
import UnknownPackages from './pages/UnknownPackages';
import Claims from './pages/Claims';
import AddUsers from './pages/AddUser';
import Reports from './pages/Reports';
import Login from './pages/Login';
import PrivateRoute from './components/PrivateRoute';
import Staff from './pages/Staff';
import Settings from './pages/Settings';
import CourierLogin from './pages/CourierLogin';
import ForgotPassword from './pages/ForgotPassword';
import ResetPasswordConfirm from './pages/ResetPasswordConfirm';
import PrivacyPolicy from './pages/PrivacyPolicy';
import DataPolicy from './pages/DataPolicy';


const AppRoutes = () => (
  <Routes>
    {/* Public Route */}
    {/* <Route path="/login" element={<Login />} /> */}
    <Route path="/" element={<Login />} />
    <Route path="/courier" element={<CourierLogin />} />
    <Route path="/forgot-password" element={<ForgotPassword />} />
    <Route path="/confirm-password" element={<ResetPasswordConfirm />} />
    <Route path="/privacypolicy" element={<PrivacyPolicy />} />
    <Route path="/datapolicy" element={<DataPolicy />} />
    {/* <Route path="/" element={<Landing />} /> */}

    {/* Private Routes */}
    <Route path="/dashboard" element={<PrivateRoute element={AdminDashboard} />} />
    <Route path="/users" element={<PrivateRoute element={Patients} />} />
    <Route path="/appointments" element={<PrivateRoute element={Appointments} />} />
    <Route path="/notifications" element={<PrivateRoute element={Notifications} />} />
    <Route path="/subscriptions" element={<PrivateRoute element={Subscriptions} />} />
   
    <Route path="/user" element={<PrivateRoute element={AddUsers} />} />
    <Route path="/staff" element={<PrivateRoute element={Staff} />} />
    <Route path="/unknown-packages" element={<PrivateRoute element={UnknownPackages} />} />
    <Route path="/claims" element={<PrivateRoute element={Claims} />} />
    <Route path="/reports" element={<PrivateRoute element={Reports} />} />
    <Route path="/settings" element={<PrivateRoute element={Settings} />} />
    
    {/* Catch-all route for unmatched paths */}
    <Route path="*" element={<Login />} />

  </Routes>
);

export default AppRoutes;
